import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "@wayflyer/auth-sdk";
import type { FundingApplicationSchemas } from "@wayflyer/api-types";

import { AIR_BANK_STATEMENT_UPDATE_API, FUNDING_APPLICATION_REVIEW_STATUS_API } from "../../components/constants";

export const useAirBankStatementUpdateMutation = (customerDomain: string) => {
  const client = useAxios();
  const queryClient = useQueryClient();
  const mutationUrl = AIR_BANK_STATEMENT_UPDATE_API.replace(":customerSlug", customerDomain);
  return useMutation({
    mutationFn: (data: FundingApplicationSchemas.AirBankStatementsUpdateParams) => {
      return client.post(mutationUrl, data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FUNDING_APPLICATION_REVIEW_STATUS_API.replace(":customerSlug", customerDomain)],
      });
    },
  });
};
